import './index.css'

import { VueQueryPlugin } from '@tanstack/vue-query'
import { createHead } from '@unhead/vue/client'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import timezonePlugin from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import { LDPlugin } from 'launchdarkly-vue-client-sdk'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import App from './App.vue'
import flagSmithPlugin from './plugins/flagsmith'
import { customerioPlugin } from './plugins/customerio'
import { segmentPlugin } from './plugins/segment'
import sentryPlugin from './plugins/sentry'
import { queryClient } from './queries/queryClient'
import router from './router'
import { getEnvVariable } from '@/env'

dayjs.extend(relativeTime)
dayjs.extend(utc)
dayjs.extend(timezonePlugin)

const pinia = createPinia()
const head = createHead()

const app = createApp(App)
  .use(flagSmithPlugin)
  .use(VueQueryPlugin, { queryClient })
  .use(router)
  .use(LDPlugin, { clientSideID: import.meta.env.VITE_LD_CLIENT_SIDE_ID, deferInitialization: true })
  .use(customerioPlugin, { writeKey: getEnvVariable('customerio_write_key') })
  .use(segmentPlugin, { writeKey: getEnvVariable('segment_write_key') })
  .use(sentryPlugin)
  .use(pinia)
  .use(head)

app.mount('#app')
